<template>
    <div class="playVideo">
        <!-- 左部分内容 -->
        <div class="VideoWrap">
            <div class="return-titleBox" @click="toReturn">
                <img src="../../assets/img/nav_return.svg" />
                <h4>{{VideoTitle}}</h4>
            </div>
            <div class="VideoBox">
                <div id="playerVideo" ref="aboutVideo"></div>
            </div>
            <div class="title-sc">
                <p>正在播放：{{VideoTitle}}</p>
                <div class="scBox" @click="shoucangFn">
                    <div v-if="isShowSc">
                        <img src="../../assets/img/CollectionBefore.svg" />
                        <span style="color: #19191A;">收藏</span>
                    </div>
                    <div v-else>
                        <img src="../../assets/img/CollectionAfter.svg" />
                        <span style="color: #0061FE;">已收藏</span>
                    </div>
                </div>
            </div>
            <div class="lookPerson">
                <div class="lookBox"><p>{{hits}}<span>人</span></p><p>观看过此课程</p></div>
                <div class="PersonBox">
                    <span v-for="(item,index) in lookUserList" :key="index">{{item.Name | formatName}}</span>
                </div>
            </div>
        </div>
        <!-- 右部分内容 -->
        <div class="CatalogWrap">
            <div class="catalogTitle">
                <div class="xf-title">
                    <p><span>{{videoXf}}</span><span>学分</span></p>
                    <h1>课程目录</h1>
                </div>
                <div class="scBox" @click="shoucangFn">
                    <div v-if="isShowSc">
                        <img src="../../assets/img/CollectionBefore.svg" />
                        <span style="color: #19191A;">收藏</span>
                    </div>
                    <div v-else>
                        <img src="../../assets/img/CollectionAfter.svg" />
                        <span style="color: #0061FE;">已收藏</span>
                    </div>
                </div>
            </div>
            <div class="courseList" v-for="(item,index) in CatalogueList" :key="index">
                <div class="noCatalogue" v-if="item.Items == null" @click="playVideo(item.ID,'clickPlay')" :style="item.ID == videoID?'background-color:#fafafa':''">
                    <div class="titleBox">
                        <h3>{{item.Title}}{{'('+item.Duration+')'}}</h3>
                    </div>
                    <div class="tnpBox">
                        <p class="num">{{item.Score}}</p>
                        <p class="play"><img src="../../assets/img/detial_play.svg" /></p>
                        <div class="progress-wrap" v-show="item.Progress != undefined && item.Progress != 0">
                            <p v-show="item.Progress >=90" style="background-image: linear-gradient(to top, #0061FE 100%, transparent 0%)"></p>
                            <p v-show="item.Progress <90" style="background-image: linear-gradient(to top, #0061FE 50%, transparent 50%)"></p>
                        </div>
                    </div>
                </div>
                <div class="haveCatalogue" v-else>
                    <h3>{{item.Title}}</h3>
                    <course-tree-list :items="item.Items" :layOut="layout" :VideoId="videoID"></course-tree-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../../components/common'
import CourseTreeList from '../../components/CourseTreeList'
export default {
    data() {
        return {
			// demo:0,
			device:undefined,  // 手机设备
            layout:false,  // 目录的布局
            isShowSc:true,  // 收藏状态
            videoXf:0,  // 学分
            hits:0,  // 点击量
            lookUserList:[],  // 观看用户
            CatalogueList:[], // 课程目录列表
            VideoTitle:'',  // 视频标题
            player:null,  // 视频播放器
            timer:null,  // 新建视频定时器
            courseId:undefined,  // 课程id
            videoID:undefined,  // 视频id
            LatelyTime:0,  // 上次视频播放位置
            ThisTime:0,  // 本次视频播放位置
            SecSplit:30,  // 同步状态间隔
            lessonList:[],  // 每个视频课程状态
            lessonId:undefined,  // 课时id
            Ptimer:null,  // 同步状态定时器
            classID:undefined,  // 获取从个人中心我的课程传过来的课时id
			synchroStut:false,  // 当视频播放结束时，需要判断是否完成视频进度
			requestTimer:null,  // 请求定时器（为了保证videoID有值）
			isFinishied:false   // 如果已完成，视频结束时不在更新视频完成状态
        }
    },
    mounted(){
        // 获取课程id
        this.courseId = this.$route.query.courseId;
        // 获取资源ID
        this.videoID = this.$route.query.id;

        // 获取从个人中心我的课程传过来的课时id   现在没必要使用这个接口
        this.classID = this.$route.query.classId;
        // 获取个人中心过来的视频相关id
        if(this.classID != undefined){
            this.getParsonalVid();
        }

        // 获取课程目录+课件学习状态
        this.getCatalogStut();

        // 获取目录组件里的vid
        this.playClick();
		
		this.appSource();
    },
    beforeDestroy(){
        this.player.pause();  // 暂停
        this.player.dispose();  // 销毁
        clearInterval(this.Ptimer);
        this.Ptimer = null;
		clearInterval(this.requestTimer);
    },
    methods: {
        // 课程目录+课件学习状态
        getCatalogStut(){
            this.$axios.all([this.getStudyStut(),this.getCatalog()]).then(this.$axios.spread((res1, res2) => {
                // 课件学习状态
                if(res1.data.Status == 0){
                    // 获取学习进度
                    this.lessonList = res1.data.Data.Lessons;
                }else if(res1.data.Status != -2){
                    this.$message({
                        message: res1.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }

                // 课程目录
                if(res2.data.Status == 0){
                    this.CatalogueList = res2.data.Data;
                    if(this.videoID == undefined && this.classID == undefined){
                        if(res2.data.Data[0].Items){
                            this.videoID = res2.data.Data[0].Items[0].ID;
                        }else{
                            this.videoID = res2.data.Data[0].ID;
                        }
                    }
                }else if(res2.data.Status != -2){
                    this.$message({
                        message: res2.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
				
				// 获取视频进度
				this.catalogStut(this.CatalogueList,this.lessonList);
				
				if(this.synchroStut) return;
				
                this.requestTimer = setInterval(() => {
                    if(this.videoID != undefined){
                        clearInterval(this.requestTimer);
                        // 获取视频详情
                        this.getVideoDetial();
                        // 获取视频观看用户
                        this.getUser();
                        // 视频点击量设置
                        this.setVideoHitNum();
                    }
                }, 100); 
            }));
        },
        // 获取视频进度状态
        catalogStut(item,append){
            item.forEach(item => {
				append.forEach(a => {
					if(item.ID === a.VideoID){
						// vue如果要给一个对象里没有的键值赋值，就要用this.$set来赋值才能被监听到
						this.$set(item, 'Progress', a.Process)
						// item.Progress = a.Process
					}
				}) 
				if(item.Items){
					this.catalogStut(item.Items,append)
				}
				// 总学分
				if(item.Kind == 1){
					this.videoXf = this.videoXf + item.Score;
				}
			})
			this.isFinishied = true;
        },
        // 获取个人中心过来的视频相关id
        getParsonalVid(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.classID
            }
            this.$axios.post(Const_Api_Root+'api/Member/MyLessons',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    let CurLessonID = this.$route.query.PersonLessonId;

                    if(this.videoID != undefined) return;
                    for(let i=0;i<res.data.Data.length;i++){
                        if(res.data.Data[i].LessonID == CurLessonID){
                            this.videoID = res.data.Data[i].VideoID;
                            // console.log(CurLessonID);
                            return;
                        }
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 课件学习状态
        getStudyStut(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId,
                "Flag":1
            }
            return this.$axios.post(Const_Api_Root+'api/Course/MyClass',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            });
        },
        // 视频点击量
        setVideoHitNum(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.videoID
            }
            this.$axios.post(Const_Api_Root+'api/Video/PutViewed',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status != -2 && res.data.Status != 0){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取视频观看用户
        getUser(){
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.videoID,
                "Num":9
            }
            this.$axios.post(Const_Api_Root+'api/Video/GetViewedUsers',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.lookUserList = res.data.Data.Rows;
                    this.hits = res.data.Data.Total;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取课程目录
        getCatalog(){
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.courseId
            }
            return this.$axios.post(Const_Api_Root+'api/Course/Catalog',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            });
        },
        // 获取当前视频状态
        getVideoStut(timestamp){
            // console.log('lessonid:',this.lessonId)
            let data = {
                "TimeStamp":timestamp,
                "ID":this.lessonId
            }
            this.$axios.post(Const_Api_Root+'api/Lesson/Info',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 将最近播放位置赋给视频播放位置(如果视频已看完，就让最近位置设为0)
                    this.ThisTime = res.data.Data.CurPos;
					if(this.ThisTime == res.data.Data.KeepSec){
						this.ThisTime = 0;
					}
                    // 同步状态间隔
                    this.SecSplit = res.data.Data.SecSplit;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 获取视频详情
        getVideoDetial(type){
            // console.log(this.videoID)
            // 获取到对应的lessonId
            for(let i=0;i<this.lessonList.length;i++){
                if(this.videoID == this.lessonList[i].VideoID){
                    this.lessonId = this.lessonList[i].LessonID;
					if(this.lessonList[i].IsFinished){
						this.isFinishied = true;
					}else{
						this.isFinishied = false;
					}
					break;
                }
            }
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            // 获取当前视频状态
            this.getVideoStut(timestamp);
            // 视频详情
            let videoData = {
                "TimeStamp":timestamp,
                "ID":this.videoID
            }
            this.$axios.post(Const_Api_Root+'/api/Course/Play',videoData,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				},
                async: true
            }).then((res)=>{
                if(res.data.Status == 0){
                    // 格式化清晰度
                    let vidUrlArr = res.data.Data.AliyunData.Data;
                    let source = {};
                    for(let i=0;i<vidUrlArr.length;i++){
						let jg = vidUrlArr[i].Definition;
                        source[jg] = vidUrlArr[i].PlayURL;
                    }
                    // 标题
                    this.VideoTitle = res.data.Data.Title;
                    // 是否已收藏
                    if(res.data.Data.IsMark){
                        this.isShowSc = false;
                    }else{
                        this.isShowSc = true;
                    }
                    // 如果是从首页进来就新建播放器
                    if(type == "clickPlay"){
                        document.title = this.VideoTitle + '_云课堂';
                        this.player.on('ended',this.endedHandle(source));
                    }else{
                        let _self = this;
                        // 初始化视频
                        this.player = new Aliplayer({
                            id: "playerVideo",
                            width: '100%',
                            height: "100%",
                            autoplay: false,
                            //支持播放地址播放,此播放优先级最高
                            source: JSON.stringify(source)
                        }, function (player) {
                            console.log("The player is created");
                            // 同步状态
                            _self.playerFn(player);
                        });
                    }
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).then((res)=>{ 
                document.title = this.VideoTitle + '_云课堂';
            }).catch((err)=>{
                throw err;
            });
        },
        // 同步状态
        SyncVideoPro(){
            // console.log(this.ThisTime,this.LatelyTime)
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.lessonId,
                "PrePos": this.ThisTime,
                "CurPos": this.LatelyTime,
            }
            this.$axios.post(Const_Api_Root+'api/Lesson/PutStut',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    // 同步数据  将本次视频位置赋给上次视频位置
                    this.ThisTime = this.LatelyTime;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
		// 判断是Android还是ios还是pc
		appSource() {
			let ua = navigator.userAgent.toLowerCase();
			if (/(iPhone|iPad|iPod|iOS)/i.test(ua)) {
				//ios
				this.device = "ios";
			} else if(/(Android)/i.test(ua)) {
				//android
				this.device = "android";
			}else{
				this.device = 'pc';
			}
		},
        // 视频操作
        playerFn(player){
            let _self = this;
            // 初始播放位置
            var seeked = false;
			//首次播放进度位置
            player.on('canplaythrough',function  (e) {
				if(seeked) return;
				seeked = true;
				// 在安卓手机上，总是从第10秒开始播放，当不设seek时就会从0秒播放
				if(_self.device == 'android'){
					player.play();
					if(_self.ThisTime<10) return;
					
					// 跳转播放时刻
					(function seekFun(){
						setTimeout(()=>{
							let Curtime = Math.floor(player.getCurrentTime());
							if(_self.ThisTime>Curtime){
								player.seek(_self.ThisTime);
								seekFun();
							}
						},1000)
					})();
				}else{
					player.seek(_self.ThisTime);
				}
            });
			player.on('ready',function(e){
				if(_self.device != 'android'){
					player.play();
				}
			});
            player.on('play',function (e){
                clearInterval(_self.Ptimer);
				
                _self.Ptimer = setInterval(() => {
                    // 当前播放时刻
                    _self.LatelyTime = Math.floor(player.getCurrentTime());
                    // 同步视频进度
                    _self.SyncVideoPro();
                }, _self.SecSplit*1000);
                console.log('play');
            });
            player.on('ended',function (e){
                if(_self.Ptimer){
                    clearInterval(_self.Ptimer);
                    _self.Ptimer = null;
                }
				
				if(_self.isFinishied) return;
				// 当视频播放结束时，获取视频进度显示在目录上
				_self.synchroStut = true;
				_self.getCatalogStut();
                console.log('end');
            });
            player.on('pause',function (e){
                if(_self.Ptimer){
                    clearInterval(_self.Ptimer);
                    _self.Ptimer = null;
                }
                // 同步视频进度
                _self.LatelyTime = Math.floor(player.getCurrentTime());
                _self.SyncVideoPro();
                console.log('pause');
            });
            player.on('error',function (e){
                if(_self.Ptimer){
                    clearInterval(_self.Ptimer);
                    _self.Ptimer = null;
                }
                console.log('error');
            });
        },
        // 播放视频
        playVideo(id,type){
            this.videoID = id;
            // 视频点击量设置
            this.setVideoHitNum();
            // 获取视频详情
            this.getVideoDetial(type);
            // 获取视频观看用户
            this.getUser();
        },
        // 目录组件里获取的视频id并播放
        playClick(){
            common.$on('playing',(id,type)=>{
                this.videoID = id;
                // 视频点击量设置
                this.setVideoHitNum();
                // 获取视频详情
                this.getVideoDetial(type); 
                // 获取视频观看用户
                this.getUser();
            });
        },
        // 改变播放地址
        endedHandle(newUrl){
            this.player.pause();  // 暂停
            this.player.dispose();  // 销毁
            if(this.timer != null) {
                clearTimeout(this.timer);
                return;
            }
            let _self = this;
            // 新建
            this.timer = setTimeout(()=>{
                this.player = new Aliplayer({
                    id: "playerVideo",
                    width: '100%',
                    height: "100%",
                    autoplay: false,
                    //支持播放地址播放,此播放优先级最高
                    source: JSON.stringify(newUrl)
                }, function (player) {
                    console.log("The player is created");
                    _self.playerFn(player);
                });
            },0);
            this.timer = null;
        },
        // 收藏
        shoucangFn(){
            this.isShowSc = !this.isShowSc;
            let flag = 0;
            if(!this.isShowSc){
                flag = 1;
            }
            // 获取unix时间戳到秒
            let timestamp = Date.parse(new Date())/1000;
            let data = {
                "TimeStamp":timestamp,
                "ID":this.videoID,
                "Flag":flag
            }
            this.$axios.post(Const_Api_Root+'api/Video/PutMark',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status != -2 && res.data.Status != 0){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                    this.isShowSc = false;
                }
            }).catch((err)=>{
                throw err;
            });
        },
        // 返回
        toReturn(){
            window.history.go(-1);
        }
    },
    filters: {
        // 格式化名字
        formatName:(val)=>{
            if(val.length == 4){
                val = val.substring(2);
            }else if(val.length == 2){
                val = val.substring(0);
            }else{
                val = val.substring(1);
            }
            return val;
        }
    },
    components: {
        CourseTreeList
    }
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px){
    .playVideo{
        padding: 0 17px;
        .VideoBox{
            width: 100%;
            height: 214px;
        }
        .title-sc{
            margin-top: 20px;
            p{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
            .scBox{
                display: none;
            }
        }
    }
    // 点赞+观看
    .lookPerson{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fafafa;
        height: 80px;
        width: 100%;
        margin: 20px 0;
        border-radius: 16px;
        .lookBox{
            margin-left: 15px;
            p:first-child{
                font-size: 20px;
                color: #19191A;
            }
            span{
                font-size: 12px;
            }
            p:last-child{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
            }
        }
        .PersonBox{
            font-size: 0;
            margin-right: 15px;
            display: flex;
            span{
                display: inline-block;
                margin-left: -10px;
                width: 30px;
                height: 30px;
                background: #0061FE;
                border: 1px solid #FAFAFA;
                border-radius: 50%;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                line-height: 30px;
            }
        }
    }
    // 目录
    .CatalogWrap{
        margin-bottom: 100px;
    }
    .catalogTitle{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 99px;
        background-color: #fafafa;
        border-radius: 16px 16px 0 0;
		border-bottom: 2px solid #fff;
    }
    // 收藏
    .scBox{
        font-size: 12px;
        cursor: pointer;
        div{
            display: flex;
            align-items: center;
            margin-right: 15px;
        }
        img{
            width: 30px;
            height: 30px;
            vertical-align: middle;
        }
    }
    // 课程目录+学分
    .xf-title{
        display: flex;
        align-items: center;
        p{
            background: #0061FE;
            border-radius: 16px 0 16px 0;
            color: #fff;
            width: 63px;
            height: 60px;
            margin-left: 20px;
            span{
                display: block;
                text-align: center;
            }
            span:first-child{
                font-size: 24px;
                margin-top: 4px;
            }
            span:last-child{
                font-size: 12px;
            }
        }
        h1{
            font-size: 24px;
            margin-left: 20px;
        }
    }
    .haveCatalogue h3{
        font-size: 12px;
        padding: 15px 0 15px 20px;
        border-bottom: 2px solid #fafafa;
    }
    .noCatalogue{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #fafafa;
        padding: 15px 0 15px 20px;
        .titleBox{
            font-size: 12px;
        }
        .tnpBox{
            display: flex;
            width: 30px;
            .num{
                margin-right: 5px;
            }
            img{
                display: none;
            }
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
@media screen and (min-width: 1445px) {
    .playVideo{
        width: 100%;
        margin: 0 0 78px;
        background-color: #fafafa;
        display: flex;
        justify-content: center;
        .VideoWrap{
            width: 782px;
            margin-right: 20px;
            margin-top: 40px;
        }
        .VideoBox{
            width: 100%;
            height: 440px;
        }
        .title-sc{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            p{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
            .scBox{
                font-size: 12px;
                cursor: pointer;
                img{
                    width: 30px;
                    height: 30px;
                    vertical-align: middle;
                    margin-right: 6px;
                }
            }
        }
        .lookPerson{
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            height: 100px;
            margin: 30px 0 40px;
            .lookBox{
                margin-left: 20px;
                p:first-child{
                    font-size: 24px;
                    color: #19191A;
                }
                span{
                    font-size: 12px;
                }
                p:last-child{
                    font-size: 12px;
                    color: rgba(25,25,26,0.80);
                }
            }
            .PersonBox{
                font-size: 0;
                margin-right: 30px;
                span{
                    display: inline-block;
                    margin-left: -10px;
                    background: #0061FE;
                    width: 47px;
                    height: 47px;
                    border-radius: 50%;
                    font-size: 14px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 47px;
                    border: 2px solid #fff;
                }
            }
        }
    }
    .CatalogWrap{
        width: 399px;
        margin-top: 90px;
        border-radius: 16px;
        background-color: #ffff;
        .catalogTitle{
            display: flex;
            align-items: center;
            width: 100%;
            height: 99px;
            border-bottom: 2px solid #fafafa;
            .scBox{
                display: none;
            }
        }
        .xf-title{
            display: flex;
            align-items: center;
            p{
                background: #0061FE;
                border-radius: 16px 0 16px 0;
                color: #fff;
                width: 63px;
                height: 60px;
                margin-left: 20px;
                span{
                    display: block;
                    text-align: center;
                }
                span:first-child{
                    font-size: 24px;
                    margin-top: 4px;
                }
                span:last-child{
                    font-size: 12px;
                }
            }
            h1{
                font-size: 24px;
                margin-left: 20px;
            }
        }
    }
    .courseList{
        width: 100%;
        padding-left: 20px;
        h3{
            font-size: 14px;
            color: #19191A;
        }
    }
    .titleBox{
        font-size: 0;
        width: 75%;
    }
    .haveCatalogue h3{
        padding: 15px 0;
        border-bottom: 2px solid #fafafa; 
    }
    .noCatalogue{
        font-size: 14px;
        color: #19191A;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 17px 15px 0;
        border-bottom: 2px solid #fafafa;
        cursor: pointer;
        &:hover{
            background: #FAFAFA;
        }
        &:hover .play{
            display: flex;
        }
        &:hover .progress-wrap{
            display: none;
        }
        .play{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);

            display: none;
            align-items: center;
            font-size: 14px;
            color: #0061FE;
            cursor: pointer;
            img{
                width: 25px;
                height: 25px;
            }
        }
        .title{
            flex: 1;
        }
        .tnpBox{
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            position: relative;
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px){
    .playVideo{
        width: 100%;
        margin: 0 0 78px;
        background-color: #fafafa;
        display: flex;
        justify-content: center;
        .VideoWrap{
            width: 740px;
            margin-right: 20px;
            margin-top: 40px;
        }
        .VideoBox{
            width: 100%;
            height: 440px;
        }
        .title-sc{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            p{
                font-size: 14px;
                color: rgba(25,25,26,0.80);
            }
            .scBox{
                font-size: 12px;
                cursor: pointer;
                img{
                    width: 30px;
                    height: 30px;
                    vertical-align: middle;
                    margin-right: 6px;
                }
            }
        }
        .lookPerson{
            display: flex;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            height: 100px;
            margin: 30px 0 40px;
            .lookBox{
                margin-left: 20px;
                p:first-child{
                    font-size: 24px;
                    color: #19191A;
                }
                span{
                    font-size: 12px;
                }
                p:last-child{
                    font-size: 12px;
                    color: rgba(25,25,26,0.80);
                }
            }
        }
        .PersonBox{
            font-size: 0;
            margin-right: 30px;
            span{
                display: inline-block;
                margin-left: -10px;
                background: #0061FE;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                line-height: 40px;
                border: 2px solid #fff;
            }
        }
    }
    .CatalogWrap{
        width: 380px;
        margin-top: 90px;
        border-radius: 16px;
        background-color: #ffff;
        .catalogTitle{
            display: flex;
            align-items: center;
            width: 100%;
            height: 99px;
            border-bottom: 2px solid #fafafa;
            .scBox{
                display: none;
            }
        }
        .xf-title{
            display: flex;
            align-items: center;
            p{
                background: #0061FE;
                border-radius: 16px 0 16px 0;
                color: #fff;
                width: 63px;
                height: 60px;
                margin-left: 20px;
                span{
                    display: block;
                    text-align: center;
                }
                span:first-child{
                    font-size: 24px;
                    margin-top: 4px;
                }
                span:last-child{
                    font-size: 12px;
                }
            }
            h1{
                font-size: 24px;
                margin-left: 20px;
            }
        }
    }
    .courseList{
        width: 100%;
        padding-left: 20px;
        h3{
            font-size: 14px;
            color: #19191A;
        }
    }
    .titleBox{
        font-size: 0;
        width: 75%;
    }
    .haveCatalogue h3{
        padding: 15px 0;
        border-bottom: 2px solid #fafafa; 
    }
    .noCatalogue{
        font-size: 14px;
        color: #19191A;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 17px 15px 0;
        cursor: pointer;
        border-bottom: 2px solid #fafafa;
        &:hover{
            background: #FAFAFA;
        }
        &:hover .play{
            display: flex;
        }
        &:hover .progress-wrap{
            display: none;
        }
        .play{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);

            display: none;
            align-items: center;
            font-size: 14px;
            color: #0061FE;
            cursor: pointer;
            img{
                width: 25px;
                height: 25px;
            }
        }
        .title{
            flex: 1;
        }
        .tnpBox{
            width: 20%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            position: relative;
        }
    }
    // 进度
    .progress-wrap{
        p{
            height: 16px;
            width: 16px;
            border-radius: 50%;
            border: 1px solid #0061FE;
            background-color: #fff; /* 浏览器不支持的时候显示 */
        }
    }
}
// 公用
ul li{
    border-bottom: 2px solid #fafafa;
}
// 返回
.return-titleBox{
    display: flex;
    align-items: center;
    margin: 10px 0;
    cursor: pointer;
    h4{
        font-size: 14px;
        font-weight: bold;
    }
    img{
        width: 30px;
        height: 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/class/PlayVideo.vue